export function verefyStateOfResponsabilityOfNumber(field: any) {
  if (field) return 1;
  return 2;
}
